<template>
  <div>
    <!--业务确认 -->
    <el-dialog :title="$t('message.serviceConfirmation')" :visible.sync="dialogVisible" width="700px" center
      :close-on-click-modal="false">
      <div class="content">
        <el-form :model="ruleForm" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <el-form-item label="业务备注（日语）:" prop="y_edit_remark">
            <el-input v-model="ruleForm.y_edit_remark" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="沟通截图:">
            <div class="imgUp">
              <el-upload :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                :on-success="handleAvatarSuccess" name="file" accept=".jpg,.jpeg,.png"
                :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-image :src="ruleForm.y_edit_image" v-if="ruleForm.y_edit_image"
                style="width: 80px; height: 80px;margin: 0 15px;" :preview-src-list="[ruleForm.y_edit_image]">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
              <i class="el-icon-delete" v-if="ruleForm.y_edit_image" @click="dely_edit_image"></i>
            </div>
          </el-form-item>
          <el-form-item label="手续费承担:" prop="y_edit_fee_payer">
            <div>
              <el-radio v-model="ruleForm.y_edit_fee_payer" label="0">客户</el-radio>
              <el-radio v-model="ruleForm.y_edit_fee_payer" label="1">RAKUMART</el-radio>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="yEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    id: { type: Number }
  },
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        y_edit_fee_payer: '0'
      },
      rules: {
        user_id: [
          {
            required: true,
            message: "请输入客户ID",
            trigger: ["blur", "change"],
          },
        ],
        client_amount: [
          {
            required: true,
            message: "请输入出金金額",
            trigger: ["blur", "change"],
          },
        ],
        client_bank_name: [
          {
            required: true,
            message: "请输入銀行名",
            trigger: ["blur", "change"],
          },
        ],
        client_bank_branch_no: [
          {
            required: true,
            message: "请输入支店番号",
            trigger: ["blur", "change"],
          },
        ],
        client_bank_branch_name: [
          {
            required: true,
            message: "请输入支店名",
            trigger: ["blur", "change"],
          },
        ],
        client_pay_type: [
          {
            required: true,
            message: "请输入預金種目",
            trigger: ["blur", "change"],
          },
        ],
        client_amount: [
          {
            required: true,
            message: "请输入口座番号",
            trigger: ["blur", "change"],
          },
        ],
        client_bank_username: [
          {
            required: true,
            message: "请输入口座名義",
            trigger: ["blur", "change"],
          },
        ],
        client_reason: [
          {
            required: true,
            message: "请输入出金申請原因",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    yEdit() {
      this.$api.financialApi.cashyEdit(this.ruleForm).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.cashList()
      })
    },
    handleAvatarSuccess(res, file) {
      this.loading.close();
      this.ruleForm.y_edit_image = res.data;
      this.$forceUpdate()
      // this.validateField("image", "ruleForm");
    },
    beforeAvatarUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      if (!isJPG) {
        this.$message.error(this.$t("message.pleaseUploadPictures"));
        return isJPG;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    dely_edit_image() {
      this.ruleForm.y_edit_image = ''
      this.$forceUpdate()
    },
  },
  watch: {
    dialogVisible() {
      this.ruleForm = {
        id: this.id,
        y_edit_fee_payer: '0',
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.content {
  padding: 0 50px;

  /deep/.el-form-item {
    .el-form-item__content {
      display: flex;
    }

    .imgUp {
      display: flex;
      align-items: flex-start;

      /deep/.avatar-uploader .el-upload {
        width: 80px;
        height: 80px;
        margin-right: 10px;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: white;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }

      .el-upload--text {
        border: 1px solid #ccc;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
      }

      /deep/.el-image {
        width: 80px !important;
        height: 80px !important;
      }

      /deep/.imgBox {
        height: 80px;
      }
    }
  }

  // /deep/.el-form-item__label {
  //   margin: 0;
  //   padding: 0;
  // }

  .row {
    display: flex;
    width: 100%;

    .item {
      flex: 1;
      display: flex;
    }
  }

  .el-icon-delete {
    font-size: 30px;
    cursor: pointer;
    line-height: 80px;

    &:hover {
      color: #B4272D;
    }
  }
}
</style>